import { Flex, FlexProps, Heading, TextLink } from '@modusign/design-system';
import { ReactNode } from 'react';

import CheckIcon from '../CheckIcon';

interface InputWrapperProps extends FlexProps<'div'> {
  children: ReactNode;
  title: string;
  linkName?: string;
  checked: boolean;
  onLinkNameClick?: () => void;
}

export default function InputWrapper({
  children,
  title,
  linkName,
  checked,
  onLinkNameClick,
  ...wrapperStyle
}: InputWrapperProps) {
  return (
    <Flex {...wrapperStyle} flexDirection="column">
      <Flex alignItems="center" justifyContent="space-between" mb={6}>
        <Flex alignItems="center">
          <CheckIcon active={checked} />
          <Heading fontSize="md" fontWeight="bold" mx={3}>
            {title}
          </Heading>
        </Flex>
        {linkName && (
          <TextLink fontSize="md" fontWeight="regular" onClick={onLinkNameClick}>
            {linkName}
          </TextLink>
        )}
      </Flex>
      {children}
    </Flex>
  );
}
